export default "__VITE_ASSET__CqNffFB3__"